import { render, staticRenderFns } from "./FooterButton.vue?vue&type=template&id=4b27359a&scoped=true&lang=pug&"
import script from "./FooterButton.vue?vue&type=script&lang=ts&"
export * from "./FooterButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b27359a",
  null
  
)

export default component.exports